
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/sub/faq",
      function () {
        return require("private-next-pages/us/sub/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/sub/faq"])
      });
    }
  